import { render, staticRenderFns } from "./formTextAddon.vue?vue&type=template&id=04455dc4&"
import script from "./formTextAddon.vue?vue&type=script&lang=js&"
export * from "./formTextAddon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports